import Show from './Show';
import Create from './Create';
import Edit from './Edit';
import List from './List';
export { Show, Create, Edit, List }
export default { Show, Create, Edit, List }
